import { render, staticRenderFns } from "./ABtestResults.vue?vue&type=template&id=586c2225&"
import script from "./ABtestResults.vue?vue&type=script&lang=js&"
export * from "./ABtestResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports